const queryString = (entries) =>
  new URLSearchParams(
    entries.flatMap(([key, value]) =>
      value != null && value !== "" && value !== "null"
        ? [[key, String(value)]]
        : [],
    ),
  ).toString();

export const buildCustomerOrdersUrl = ({ uamId, verticalId, countryId }) =>
  `/customerOrders?${queryString([
    ["uamId", uamId],
    ["verticalId", verticalId],
    ["countryId", countryId],
  ])}`;

export const buildPunchOrderUrl = ({ uamId, verticalId, countryId }) =>
  `/punchOrder?${queryString([
    ["uamId", uamId],
    ["verticalId", verticalId],
    ["countryId", countryId],
  ])}`;

export const buildPaymentPreferenceUrl = ({
  orderId,
  countryId,
  switchToLoan = false,
}) =>
  `/paymentPreference?${queryString([
    ["order_id", orderId],
    ["countryId", countryId],
    ...(switchToLoan ? [["switch_to_loan", "true"]] : []),
  ])}`;

export const buildBatchPreferenceUrl = ({ orderId, uamId, countryId }) =>
  `/batchPreference?${queryString([
    ["order_id", orderId],
    ["uam_id", uamId],
    ["countryId", countryId],
  ])}`;

export const buildEditPaymentsUrl = ({ orderId, countryId }) =>
  `/editPayments?${queryString([
    ["order_id", orderId],
    ["countryId", countryId],
  ])}`;
